
var ge;
function loadTemplatesFromFile(fileUrl) {
    $.get(fileUrl, function(data) {
        $(data).filter('script[type="text/template"]').each(function() {
            var id = $(this).attr('id');
            var content = $(this).html();
            $.JST._templates[id] = content;
        });
    });
}

function startGantt(project){
  jQuery(document).ready(function() {
    // Lista de URLs dos scripts a serem carregados
    var scriptUrls = [
      '/assets/jQueryGantt/libs/jquery/jquery.livequery.1.1.1.min.js',
      '/assets/jQueryGantt/libs/jquery/jquery.timers.js',
      '/assets/jQueryGantt/libs/utilities.js',
      '/assets/jQueryGantt/libs/forms.js',
      '/assets/jQueryGantt/libs/date.js',
      '/assets/jQueryGantt/libs/dialogs.js',
      '/assets/jQueryGantt/libs/layout.js',
      '/assets/jQueryGantt/libs/i18nJs.pt-br.js',
      '/assets/jQueryGantt/libs/jquery/dateField/jquery.dateField.js',
      '/assets/jQueryGantt/libs/jquery/JST/jquery.JST.js',
      '/assets/jQueryGantt/libs/jquery/valueSlider/jquery.mb.slider.js',
      '/assets/jQueryGantt/libs/jquery/svg/jquery.svg.min.js',
      '/assets/jQueryGantt/libs/jquery/svg/jquery.svgdom.1.8.js',
      'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js',
      '/assets/jQueryGantt/js/ganttUtilities.js',
      '/assets/jQueryGantt/js/ganttTask.js',
      '/assets/jQueryGantt/js/ganttDrawerSVG.js',
      '/assets/jQueryGantt/js/ganttZoom.js',
      '/assets/jQueryGantt/js/ganttGridEditor.js',
      '/assets/jQueryGantt/js/ganttMaster.js'
    ];
    var styleUrls = [
      '/assets/jQueryGantt/libs/jquery/dateField/jquery.dateField.css',
      '/assets/jQueryGantt/css/gantt.css',
      '/assets/jQueryGantt/css/platform.css',
      'https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css'
    ]
    
    var styleMediaUrls = [
      '/assets/jQueryGantt/libs/jquery/valueSlider/mb.slider.css',
      '/assets/jQueryGantt/css/ganttPrint.css',
    ]
    
    const baseUrl = $("base").attr("href")?.replace(/\/$/, "");

    function setBaseUrl(baseUrl, urls){
      return urls.map(url => baseUrl + url);
    }
    
    scriptUrls = setBaseUrl(baseUrl, scriptUrls);
    styleUrls = setBaseUrl(baseUrl, styleUrls);
    styleMediaUrls = setBaseUrl(baseUrl, styleMediaUrls);

    // Função para carregar todos os scripts na ordem
    function loadAllScripts(urls,urlsCss,urlsCssMedia) {
        let promiseChain = Promise.resolve();
        urls.forEach(url => {
            promiseChain = promiseChain.then(() => $.getScript(url))
                .then(() => {
                })
                .catch((error) => {
                    console.error(`Erro ao carregar o script ${url}:`, error);
                });
        });
        urlsCssMedia.forEach(url =>
          promiseChain = promiseChain.then(() => {
                var link = $('<link/>', {
                  rel: 'stylesheet',
                  type: 'text/css',
                  href: url,
                  media:"print"
              });
              $('head').prepend(link);
              })
              .then(() => {
              })
              .catch((error) => {
                  console.error(`Erro ao carregar o script ${url}:`, error);
              })
        )
        
        urlsCss.forEach(url =>
          promiseChain = promiseChain.then(() => {
              var link = $('<link/>', {
                  rel: 'stylesheet',
                  type: 'text/css',
                  href: url
              });
              $('head').prepend(link);
              })
              .then(() => {
              })
              .catch((error) => {
                  console.error(`Erro ao carregar o script ${url}:`, error);
              })
        )
        return promiseChain;
    }

    // Carregar todos os scripts e executar a função quando todos forem carregados
    loadAllScripts(scriptUrls,styleUrls ,styleMediaUrls)
        .then(() => {
            $.get(baseUrl + '/assets/jQueryGantt/template.html', function(templates) {
                /*$.JST.loadDecorator("RESOURCE_ROW", function(resTr, res){
                resTr.find(".delRes").click(function(){$(this).closest("tr").remove()});
                });*/
                /*$(document).on("change", "#load-file", function() {
                    var uploadedFile = $("#load-file").prop("files")[0];
                    upload(uploadedFile);
                });
                var canWrite=true;*/ //this is the default for test purposes

                // here starts gantt initialization
                $("#workSpace").empty();
                
                $.get(baseUrl + '/assets/jQueryGantt/helpTemplate.html', function(helpTemplate) {
                  ge = new GanttMaster(templates, helpTemplate, project);
                  ge.set100OnClose=true;

                  ge.shrinkParent=true;
                  ge.init($("#workSpace"),$(templates),$(helpTemplate));

                  
                  loadI18n(); //overwrite with localized ones

                  //in order to force compute the best-fitting zoom level
                  delete ge.gantt.zoom;

                  ge.loadProject(project);
                  ge.checkpoint(); //empty the undo stack
                  if(ge.baselines.length > 0 && project.canSeeMonitoramento){
                    $('.changeView').show();
                  }
                  else{
                    $('.changeView').hide();
                  }
                  if(ge.baselines.length > 0){
                    $('.changeView2').show();
                  }
                  else{
                    $('.changeView2').hide();
                  }
                  if(project.isHistory){
                    $(".ganttButtonBar").find('.isHistoryMode').show();
                  }
                  else{
                    $(".ganttButtonBar").find('.isHistoryMode').hide();
                  }

                  if(project.canEdit){
                    if(project.canWrite){
                      $(".taskEditRow").find(".requireCanWrite").show();
                      $(".ganttButtonBar").find(".requireCanWrite").show();
                      $(".ganttButtonBar").find(".requireNotWrite").hide();
                      if(!project.canSaveBaseline){
                        $(".ganttButtonBar").find(".requireSaveBaseline").hide();
                      }
                      if(!project.canSeeMonitoramento){
                        $(".ganttButtonBar").find(".changeView").hide();
                      }
                    }else{
                      console.log( $(".ganttButtonBar").find(".requireNotWrite").show())
                      $(".ganttButtonBar button.requireWrite").attr("disabled","true");
                      $(".taskEditRow").find(".requireCanWrite").hide();
                      $(".ganttButtonBar ").find(".requireCanWrite").hide();
                      $(".ganttButtonBar").find(".requireNotWrite").show();
                    }
                  }
                  else{
                    $(".ganttButtonBar button.requireWrite").attr("disabled","true");
                      $(".taskEditRow").find(".requireCanWrite").hide();
                      $(".ganttButtonBar ").find(".requireCanWrite").hide();
                      $(".ganttButtonBar").find(".requireNotWrite").hide();
                  }
                });
                //initializeHistoryManagement(ge.tasks[0].id);
            });
        })
        .catch((error) => {
            console.error('Erro ao carregar um ou mais scripts:', error);
        });
  });
}
function loadI18n(){
    GanttMaster.messages = {
        "CANNOT_WRITE":"Nenhuma permissão para alterar a seguinte tarefa:",
        "CHANGE_OUT_OF_SCOPE":"A atualização do projeto não é possível porque você não tem direitos para atualizar um projeto pai.",
        "START_IS_MILESTONE":"A data de início é um marco.",
        "END_IS_MILESTONE":"A data de término é um marco.",
        "TASK_HAS_CONSTRAINTS":"Tarefa tem restrições.",
        "GANTT_ERROR_DEPENDS_ON_OPEN_TASK":"Erro: há dependência de uma tarefa aberta.",
        "GANTT_ERROR_DESCENDANT_OF_CLOSED_TASK":"Erro: devido a um descendente de uma tarefa fechada.",
        "TASK_HAS_EXTERNAL_DEPS":"Esta tarefa possui dependências externas.",
        "GANNT_ERROR_LOADING_DATA_TASK_REMOVED":"Erro no Gantt ao carregar dados da tarefa que foi removida.",
        "CIRCULAR_REFERENCE":"Referência circular.",
        "CANNOT_DEPENDS_ON_ANCESTORS":"Não pode depender dos ancestrais.",
        "INVALID_DATE_FORMAT":"Os dados inseridos são inválidos para o formato do campo.",
        "GANTT_ERROR_LOADING_DATA_TASK_REMOVED":"Ocorreu um erro ao carregar os dados. Uma tarefa foi descartada.",
        "CANNOT_CLOSE_TASK_IF_OPEN_ISSUE":"Não é possível fechar uma tarefa com problemas abertos.",
        "TASK_MOVE_INCONSISTENT_LEVEL":"Você não pode trocar tarefas de profundidade diferente.",
        "CANNOT_MOVE_TASK":"Você não pode mover essa tarefa.",
        "PLEASE_SAVE_PROJECT":"Por favor, salve o projeto.",
        "GANTT_SEMESTER":"Semestre",
        "GANTT_SEMESTER_SHORT":"s.",
        "GANTT_QUARTER":"Trimestre",
        "GANTT_QUARTER_SHORT":"q.",
        "GANTT_WEEK":"Semana",
        "GANTT_WEEK_SHORT":"w."
    };
}
function createNewResource(el) {
var row = el.closest("tr[taskid]");
var name = row.find("[name=user_cpf_txt]").val();
var url = contextPath + "/applications/teamwork/resource/resourceNew.jsp?CM=ADD&name=" + encodeURI(name);

openBlackPopup(url, 700, 320, function (response) {
    //fillare lo smart combo
    if (response && response.resId && response.resName) {
    //fillare lo smart combo e chiudere l'editor
    row.find("[name=user_cpf]").val(response.resId);
    row.find("[name=user_cpf_txt]").val(response.resName).focus().blur();
    }

});
}

//cria a msg de alerta
function setAlert(self, alertClass, text){
  self.workSpace.find(".divAlert").remove();
  var template = $(self.template).find("#alertItem").html();
  var alert = $(template);
  alert.find("#alert").addClass(alertClass);
  alert.find("#alertText").text(text);
  alert.find("button").click(function(){
    alert.remove();
  })
  self.workSpace.append(alert);
}

//cria um modal de alerta
function setModalAlert(type, text, extraMsg = null, func = null){
  var self = this;
  var template = $(self.ge.template).find("#baseModal");
  var base = $(template.html());
  base.find(".footerModal").remove();
  base.find(".titleModal").text(type=='success'?'Sucesso':'Erro');
  var baseAviso = $(self.ge.template).find("#baseModalAvisos");
  base.find(".baseFields").append(baseAviso.html())
  base.find("#description").text(text);
  if(extraMsg){
    base.find("#extraMsg")
    .removeClass("hidden")
    .off("click")
    .on("click", function () {
        navigator.clipboard.writeText(extraMsg)
            .then(() => {
                alert("Copiado para a área de transferência!");
            })
            .catch(err => {
                console.error("Erro ao copiar:", err);
            });
    });
  }
  var templateType = $(self.ge.template).find("#icon_"+type);
  base.find("#divModalAvisos").prepend(templateType.html());
  base.find("#closeButton").click(function(){
    if(func){
      func();
    }
    else{
      base.remove();
    }
  })
  var ndo = createModalPopup('10%', '300px').append(base);
}

//cria o load
function setLoad(){
  $("#workSpace").find("#load-div").remove();
  var loadDiv = $('<div></div>').addClass('load-div').attr("id",'load-div');
  var loadBody = $('<div></div>').addClass('load-body');

  var barContainer = $('<div></div>').addClass('bar-container');
  var barA = $('<div></div>').addClass('bar bar-a');
  var barB = $('<div></div>').addClass('bar bar-b');
  var barC = $('<div></div>').addClass('bar bar-c');

  barContainer.append(barA, barB, barC);
  loadBody.append(barContainer);
  loadDiv.append(loadBody);
  console.log($("#workSpace"))
  $("#workSpace").append(loadDiv);
}
function removeLoad(){
  $("#workSpace").find("#load-div").remove();
}

function filterData(filters, data){
  var result = [];
  filters.forEach((filter) =>{
    result = data.filter((d)=> filter.data.split(" ").every((f)=> standardizeText(d['label']).includes(standardizeText(f)) )
     )
  })
  return result;
}
function standardizeText(text){
  var result = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  return result;
}

function loadGanttFromServer(taskId, callback) {

  //this is a simulation: load data from the local storage if you have already played with the demo or a textarea with starting demo data
  var ret=loadFromLocalStorage();

  //this is the real implementation
  /*
  //var taskId = $("#taskSelector").val();
  var prof = new Profiler("loadServerSide");
  prof.reset();

  $.getJSON("ganttAjaxController.jsp", {CM:"LOADPROJECT",taskId:taskId}, function(response) {
    //console.debug(response);
    if (response.ok) {
      prof.stop();

      ge.loadProject(response.project);
      ge.checkpoint(); //empty the undo stack

      if (typeof(callback)=="function") {
        callback(response);
      }
    } else {
      jsonErrorHandling(response);
    }
  });
  */

  return ret;
}

function upload(uploadedFile) {
  var fileread = new FileReader();
  
  fileread.onload = function(e) {
    var content = e.target.result;
    var intern = JSON.parse(content); // Array of Objects.
    //console.log(intern); // You can index every object
    
    ge.loadProject(intern);
    ge.checkpoint(); //empty the undo stack

  };

  fileread.readAsText(uploadedFile);
}
function setEditGantt(status) {
  //console.log(ge.gantt.redrawTasks)
  ge.permissions.canWrite = status;
  ge.redraw();
  ge.gantt.redrawTasks()
  $(".ganttButtonBar button.requireWrite").attr("disabled",!status);
  if(status){
    $(".taskEditRow").find(".requireCanWrite").show();
    $(".ganttButtonBar").find(".requireCanWrite").show();
    $(".ganttButtonBar").find(".requireNotWrite").hide();
    if(!ge.permissions.canSaveBaseline){
      $(".ganttButtonBar").find(".requireSaveBaseline").hide();
    }
    if(!ge.permissions.canSeeMonitoramento){
      $(".ganttButtonBar").find(".changeView").hide();
    }
  }else{
    $(".taskEditRow").find(".requireCanWrite").hide();
    $(".ganttButtonBar ").find(".requireCanWrite").hide();
    $(".ganttButtonBar").find(".requireNotWrite").show();
  }
}

function saveGanttOnServer(saveBaseline = false) {
  if (confirm("Você tem certeza que deseja salvar?") == true) {
    var data = ge.saveProject();
    data['is_baseline'] = saveBaseline;
    ge.saveData(data);
  }
}

function returnGantt(){
  const url = new URL(window.location.href);
  url.searchParams.delete('history');
  window.location.href = url.toString();
}

function returnEntregas(){
  const baseUrl = new URL(window.location.href);
  const url = window.location.origin;
  const pf_id = baseUrl.searchParams.get('pf_id');
  const basePath = url.includes('localhost')? '' : '/app';
  if(pf_id){
    const path = basePath + '/projetos/projeto/' + pf_id + '/entregas';
    window.location.href = url + path;
  }
  else{
    const pg_id = baseUrl.searchParams.get('pg_id');
    const path = basePath + '/projetos/programa/' + pg_id + '/cadastro';
    window.location.href = url + path;
  }
}

function reloadGantt() {
  if (confirm("Você tem certeza que deseja cancelar a edição? \n Todas as edições feitas não serão salvas") == true) {
    startGantt(ge.project);
  }
}

function changeView(){
  $('#changeView').html(ge.showBaselines?'Visualizar <br> Monitoramento':'Ocultar <br> Monitoramento');
  ge.showBaselines = !ge.showBaselines;
  ge.redraw();
}
function changeView2(){
  $('#changeView2').html(ge.showBaselines2?'Visualizar <br> Linha Base':'Ocultar <br> Linha Base');
  ge.showBaselines2 = !ge.showBaselines2;
  ge.redraw();
}

function openHelpModal(templateId, openModal = false){
  var bodyTemplate = $(ge.helpTemplate).find("#" + templateId);
  var body =$(bodyTemplate.html());
  var template = $(ge.helpTemplate).find("#helpModal");
  var base = $(template.html());
  base.find("#template-container").empty();
  base.find("#template-container").append(body);
  modal = createModalPopup(800, 450).append(base);
  modal.attr("id", "helpModalPopup");
}

function addButtonHelp(modalId){
  var helpButton = $('<button></button>')
    .addClass('help-button')
    .attr('title', 'Abrir Menu de ajuda')
    .text('question_mark')
    .attr('data-modal-id', modalId)
    .attr("type", "button");
  return helpButton;
}

// Function to download data to a file
function download(data, filename, type) {
  var file = new Blob([data], {type: type});
  if (window.navigator.msSaveOrOpenBlob) // IE10+
    window.navigator.msSaveOrOpenBlob(file, filename);
  else { // Others
    var a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function() {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);  
    }, 0); 
  }
}

function newProject(){
  clearGantt();
}


function clearGantt() {
  ge.reset();
}

//-------------------------------------------  Get project file as JSON (used for migrate project from gantt to Teamwork) ------------------------------------------------------
function getFile() {
  $("#gimBaPrj").val(JSON.stringify(ge.saveProject()));
  $("#gimmeBack").submit();
  $("#gimBaPrj").val("");

  /*  var uriContent = "data:text/html;charset=utf-8," + encodeURIComponent(JSON.stringify(prj));
  neww=window.open(uriContent,"dl");*/
}


function loadFromLocalStorage() {
  var ret;
  if (localStorage) {
    if (localStorage.getObject("teamworkGantDemo")) {
      ret = localStorage.getObject("teamworkGantDemo");
    }
  }

  //if not found create a new example task
  if (!ret || !ret.tasks || ret.tasks.length == 0){
    ret=getDemoProject();
  }
  return ret;
}


function saveInLocalStorage() {
  var prj = ge.saveProject();

  if (localStorage) {
    localStorage.setObject("teamworkGantDemo", prj);
  }
}


//-------------------------------------------  Open a black popup for managing resources. This is only an axample of implementation (usually resources come from server) ------------------------------------------------------
//Desativado- ele abria um modal para escolher as pessoas do projeto como um todo. Essa funcionalidade agora está dentro de cada linha
function editResources(){
  //make resource editor
  var resourceEditor = $.JST.createFromTemplate({}, "RESOURCE_EDITOR");
  var resTbl=resourceEditor.find("#resourcesTable");

  for (var i=0;i<ge.resources.length;i++){
    var res=ge.resources[i];
    resTbl.append($.JST.createFromTemplate(res, "RESOURCE_ROW"))
  }


  //bind add resource
  resourceEditor.find("#addResource").click(function(){
    resTbl.append($.JST.createFromTemplate({id:"new",name:"resource"}, "RESOURCE_ROW"))
  });

  //bind save event
  resourceEditor.find("#resSaveButton").click(function(){
    var newRes=[];
    //find for deleted res
    for (var i=0;i<ge.resources.length;i++){
      var res=ge.resources[i];
      var row = resourceEditor.find("[resId="+res.id+"]");
      if (row.length>0){
        //if still there save it
        var name = row.find("input[name]").val();
        if (name && name!="")
          res.name=name;
        newRes.push(res);
      } else {
        //remove assignments
        for (var j=0;j<ge.tasks.length;j++){
          var task=ge.tasks[j];
          var newAss=[];
          for (var k=0;k<task.assigs.length;k++){
            var ass=task.assigs[k];
            if (ass.user_cpf!=res.id)
              newAss.push(ass);
          }
          task.assigs=newAss;
        }
      }
    }

    //loop on new rows
    var cnt=0
    resourceEditor.find("[resId=new]").each(function(){
      cnt++;
      var row = $(this);
      var name = row.find("input[name]").val();
      if (name && name!="")
        newRes.push (new Resource("tmp_"+new Date().getTime()+"_"+cnt,name));
    });

    ge.resources=newRes;

    closeBlackPopup();
    ge.redraw();
  });


  var ndo = createModalPopup(400, 500).append(resourceEditor);
}

function initializeHistoryManagement(taskId){

  //retrieve from server the list of history points in millisecond that represent the instant when the data has been recorded
  //response: {ok:true, historyPoints: [1498168800000, 1498600800000, 1498687200000, 1501538400000, …]}
  $.getJSON(contextPath+"/applications/teamwork/task/taskAjaxController.jsp", {CM: "GETGANTTHISTPOINTS", OBJID:taskId}, function (response) {

    //if there are history points
    if (response.ok == true && response.historyPoints && response.historyPoints.length>0) {

      //add show slider button on button bar
      var histBtn = $("<button>").addClass("button textual icon lreq30 lreqLabel").attr("title", "SHOW_HISTORY").append("<span class=\"teamworkIcon\">&#x60;</span>");

      //clicking it
      histBtn .click(function () {
        var el = $(this);
        var ganttButtons = $(".ganttButtonBar .buttons");
        //is it already on?
        if (!ge.element.is(".historyOn")) {
          ge.element.addClass("historyOn");
          ganttButtons.find(".requireCanWrite").hide();
          $(".taskEditRow").find(".requireCanWrite").hide();

          //load the history points from server again
          showSavingMessage();
          $.getJSON(contextPath + "/applications/teamwork/task/taskAjaxController.jsp", {CM: "GETGANTTHISTPOINTS", OBJID: ge.tasks[0].id}, function (response) {
            jsonResponseHandling(response);
            hideSavingMessage();
            if (response.ok == true) {
              var dh = response.historyPoints;
              if (dh && dh.length > 0) {
                //si crea il div per lo slider
                var sliderDiv = $("<div>").prop("id", "slider").addClass("lreq30 lreqHide").css({"display":"inline-block","width":"500px"});
                ganttButtons.append(sliderDiv);

                var minVal = 0;
                var maxVal = dh.length-1 ;

                $("#slider").show().mbSlider({
                  rangeColor : '#2f97c6',
                  minVal     : minVal,
                  maxVal     : maxVal,
                  startAt    : maxVal,
                  showVal    : false,
                  grid       :1,
                  formatValue: function (val) {
                    return new Date(dh[val]).format();
                  },
                  onSlideLoad: function (obj) {
                    this.onStop(obj);

                  },
                  onStart    : function (obj) {},
                  onStop     : function (obj) {
                    var val = $(obj).mbgetVal();
                    showSavingMessage();
                    /**
                     * load the data history for that milliseconf from server
                     * response in this format {ok: true, baselines: {...}}
                     *
                     * baselines: {61707: {duration:1,endDate:1550271599998,id:61707,progress:40,startDate:1550185200000,status:"STATUS_WAITING",taskId:"3055"},
                     *            {taskId:{duration:in days,endDate:in millis,id:history record id,progress:in percent,startDate:in millis,status:task status,taskId:"3055"}....}}                     */

                    $.getJSON(contextPath + "/applications/teamwork/task/taskAjaxController.jsp", {CM: "GETGANTTHISTORYAT", OBJID: ge.tasks[0].id, millis:dh[val]}, function (response) {
                      jsonResponseHandling(response);
                      hideSavingMessage();
                      if (response.ok ) {
                        ge.baselines=response.baselines;
                        ge.showBaselines=true;
                        ge.baselineMillis=dh[val];
                        ge.redraw();
                      }
                    })

                  },
                  onSlide    : function (obj) {
                    clearTimeout(obj.renderHistory);
                    var self = this;
                    obj.renderHistory = setTimeout(function(){
                      self.onStop(obj);
                    }, 200)

                  }
                });
              }
            }
          });


          // closing the history
        } else {
          //remove the slider
          $("#slider").remove();
          ge.element.removeClass("historyOn");
          if (ge.permissions.canWrite){
            ganttButtons.find(".requireCanWrite").show();
            $(".taskEditRow").find(".requireCanWrite").show();
          }
          ge.showBaselines=false;
          ge.baselineMillis=undefined;
          ge.redraw();
        }

      });
      $("#saveGanttButton").before(histBtn);
    }
  })
}

function showBaselineInfo (event,element){
//alert(element.attr("data-label"));
$(element).showBalloon(event, $(element).attr("data-label"));
ge.splitter.secondBox.one("scroll",function(){
  $(element).hideBalloon();
})
}
